import React from 'react'

function WelcomerSmallIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" {...props}>
      <defs>
        <clipPath id="WelcomerSmallIcon">
          <path fill="none" stroke="#707070" strokeWidth="1" d="M216 1861h26v26h-26z" data-name="Path 91599"></path>
        </clipPath>
      </defs>
      <g data-name="Group 57298" transform="translate(-40 -226)">
        <rect
          width="40"
          height="40"
          fill="#ffefed"
          data-name="Rectangle 2345"
          rx="20"
          transform="translate(40 226)"
        ></rect>
        <g clipPath="url(#WelcomerSmallIcon)" data-name="Mask Group 807" transform="translate(-169 -1628)">
          <g fill="#263238" data-name="Group 58779" transform="translate(5.2 71.632)">
            <g data-name="Group 58782" transform="translate(-.115)">
              <path
                d="M17.4 7.606h-2.147v-1.2H17.4a.4.4 0 00.4-.4V1.192h-2.213v-1.2H19v6.014a1.6 1.6 0 01-1.6 1.6z"
                data-name="Path 91587"
                transform="translate(214.653 1803.697)"
              ></path>
              <path
                d="M18.4 7.606h-2.147a1.6 1.6 0 01-1.6-1.6V-.008h3.414v1.2h-2.214v4.814a.4.4 0 00.4.4H18.4z"
                data-name="Path 91589"
                transform="translate(199.6 1803.697)"
              ></path>
            </g>
            <path
              d="M13.261 12.835H-.6V2.762H.6v8.872h11.461V2.762h1.2z"
              data-name="Path 91588"
              transform="translate(217.544 1799.302)"
            ></path>
            <path
              d="M6.454 5h-1.2a1.9 1.9 0 00-1.9-1.9H2.5A1.9 1.9 0 00.6 5H-.6a3.1 3.1 0 013.1-3.1h.854a3.1 3.1 0 013.1 3.1z"
              data-name="Path 91590"
              transform="translate(221.091 1790.699)"
            ></path>
            <path
              d="M1.2 1.2v3.347a2.8 2.8 0 002.8 2.8h8.188a2.8 2.8 0 002.8-2.8V1.2H1.2M0 0h16.188v4.547a4 4 0 01-4 4H4a4 4 0 01-4-4z"
              data-name="Rectangle 10115"
              transform="translate(215.745 1794.75)"
            ></path>
            <path d="M.6 5.248H-.6V0H.6z" data-name="Line 2687" transform="translate(226.748 1800.631)"></path>
            <path d="M.6 5.248H-.6V0H.6z" data-name="Line 2688" transform="translate(221.275 1800.631)"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default WelcomerSmallIcon
